<h1 mat-dialog-title [class.error-title]="data.isError">{{ data.title }}</h1>
<div mat-dialog-content>
  <p>{{ data.message }}</p>
</div>
<mat-dialog-actions align="end">
  <button mat-flat-button mat-dialog-close class="primary-color">
    {{ data.buttonText || 'OK' }}
  </button>
</mat-dialog-actions>
